import PageWrapper from "../components/animations/PageWrapper";
import AnimatedCard from "../components/ui/AnimatedCard";
import { Link } from "react-router-dom";
import { Copy } from "lucide-react";
import { useState } from "react";
import styles from "./Accueil.module.css";

export default function Accueil() {
  const [copied, setCopied] = useState(false);

  return (
    <main className="page-content">
      <PageWrapper>
        <main className={styles.main}>
          {/* A propos */}
          <section className={`${styles.section} ${styles.about}`}>
            <h2>À propos</h2>
            <AnimatedCard>
              <p>
              Actuellement à la recherche d’un <strong>stage</strong> de fin d’études de <strong>6 mois</strong>, à partir de <strong>février 2026</strong>, dans Paris et ses alentours, je suis étudiant en informatique à l’<strong>INSA de Rouen</strong>. Passionné par de nombreux domaines techniques tels que le <strong>développement logiciel</strong>, le <strong>machine learning</strong> et l’<strong>intelligence artificielle</strong>, j’aime explorer les nouvelles technologies, comprendre leur fonctionnement en profondeur et <strong>créer des solutions concrètes</strong> à partir d’idées abstraites. En dehors du cadre académique, je pratique des activités qui me tiennent à cœur : le <em>piano</em>, l’<em>escalade</em> et le <em>vélo</em>, qui m’apportent équilibre et inspiration au quotidien. Ce site web présente un aperçu synthétique de mon <strong>parcours</strong>, de mes <strong>compétences</strong> et des moyens de me <strong>contacter</strong> si vous souhaitez échanger ou collaborer.              </p>
            </AnimatedCard>
          </section>

          {/* Navigation rapide */}
          <section className={`${styles.section} ${styles.quickNav}`}>
            <Link to="/experiences" className={styles.quickButton}>
              Expériences
            </Link>
            <Link to="/projets" className={styles.quickButton}>
              Projets
            </Link>
            <Link to="/formations" className={styles.quickButton}>
              Formations
            </Link>
            <Link to="/competences" className={styles.quickButton}>
              Compétences
            </Link>
          </section>

          {/* Contact */}
          <section id='contact'>
              <h2>Contact</h2>
              <AnimatedCard>
                <p className="email-row">
                  E-mail :
                  <a href="mailto:ulysse.gillotletang@gmail.com" className="link-accent" id="contact-email">ulysse.gillotletang@gmail.com</a>
                  <button
                    className={`copy-btn`}
                    type="button"
                    aria-label="Copier l'adresse e-mail"
                    onClick={async () => {
                      const email = 'ulysse.gillotletang@gmail.com';
                      try {
                        if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
                          await navigator.clipboard.writeText(email);
                        } else {
                          // fallback
                          const ta = document.createElement('textarea');
                          ta.value = email;
                          document.body.appendChild(ta);
                          ta.select();
                          document.execCommand('copy');
                          document.body.removeChild(ta);
                        }
                        setCopied(true);
                        setTimeout(() => setCopied(false), 1800);
                      } catch (e) {
                        console.error('Copy failed', e);
                      }
                    }}
                  >
                    <Copy size={16} />
                  </button>
                  {copied ? <span className="copied-tip">Copié !</span> : null}
                </p>
                <p>LinkedIn : <a href="https://www.linkedin.com/in/ulysse-gillot-létang-247244227" className="link-accent">Mon LinkedIn</a></p>
                <p>GitHub : <a href="https://github.com/lyngarr" className="link-accent">Mon GitHub</a></p>
              </AnimatedCard>
            </section>
        </main>
      </PageWrapper>
    </main>
  );
}
